import React from "react";
import cookieManager from "../components/CookieManager";
import Constants from "../components/Constants";

const withAuth = (WrappedComponent) => {
  return class extends React.Component {
    state = {
      isAuthenticated: false,
      loading: true,
    };

    componentDidMount() {
      const accessToken = cookieManager.get(Constants.ACCESS_TOKEN);

      if (accessToken) {
        this.setState({ isAuthenticated: true, loading: false });
      } else {
        this.setState({ isAuthenticated: false, loading: false });
      }
    }

    render() {
      const { isAuthenticated, loading } = this.state;

      if (loading) {
        return <p>Verifying...</p>;
      }

      if (!isAuthenticated) {
        window.location.href = "/login";
        return null;
      }

      return <WrappedComponent {...this.props} />;
    }
  };
};

export default withAuth;
